// src/features/inventory/hooks/useLots.js
import { useState, useCallback } from 'react';
import { lotsAPI } from '../services/lots';
import { useApi } from '../../../hooks/api/useApi';

export function useLots() {
  const [lots, setLots] = useState([]);
  const [currentLot, setCurrentLot] = useState(null);
  const { loading, error, execute, clearError } = useApi();

  const fetchLotsByItem = useCallback(async (itemId) => {
    const result = await execute(() => lotsAPI.getByItem(itemId));
    if (result.success) {
      setLots(result.data.data || []);
    }
    return result;
  }, [execute]);

  const fetchLotById = useCallback(async (lotId) => {
    const result = await execute(() => lotsAPI.getById(lotId));
    if (result.success) {
      setCurrentLot(result.data.data);
    }
    return result;
  }, [execute]);

  return { lots, currentLot, loading, error, clearError, fetchLotsByItem, fetchLotById };
}
